import PlusIcon from '@heroicons/react/outline/PlusIcon';
import { PostTypeContext } from '@tribeplatform/gql-client/types';
import { useAuthToken } from '@tribeplatform/react-sdk/hooks';
import { useI18n } from '../../i18n';
import { emptyCommandBarResult } from '../types';
export const useCommandBarPosts = () => {
    var _a;
    const intl = useI18n();
    const { data: { network }, isLoading, } = useAuthToken();
    const availablePostTypes = (_a = network === null || network === void 0 ? void 0 : network.postTypes) === null || _a === void 0 ? void 0 : _a.filter(postType => {
        var _a, _b;
        return ((_b = (_a = postType === null || postType === void 0 ? void 0 : postType.authMemberProps) === null || _a === void 0 ? void 0 : _a.availableSpaces) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
            (postType === null || postType === void 0 ? void 0 : postType.context) === PostTypeContext.post &&
            (postType === null || postType === void 0 ? void 0 : postType.slug) !== 'tribe-message';
    });
    if (!(availablePostTypes === null || availablePostTypes === void 0 ? void 0 : availablePostTypes.length))
        return emptyCommandBarResult;
    const categoryTexts = {
        newPost: intl.$t({
            id: 'CommandBar.Posts.NewPost',
            defaultMessage: 'New post',
        }),
    };
    return {
        isLoading,
        actions: [
            {
                name: intl.$t({
                    id: 'CommandBar.Posts.CreateNewPost',
                    defaultMessage: 'Create new post',
                }),
                url: '/new',
                icon: PlusIcon,
                category: categoryTexts.newPost,
                hotkey: 'n',
            },
            ...availablePostTypes === null || availablePostTypes === void 0 ? void 0 : availablePostTypes.map(postType => {
                return {
                    name: intl.$t({
                        id: 'CommandBar.Posts.CreateNewPostWithType',
                        defaultMessage: 'Create new {post_type_name}',
                    }, { post_type_name: postType.name.toLowerCase() }),
                    url: `/new?post_type=${postType.id}`,
                    icon: PlusIcon,
                    category: categoryTexts.newPost,
                };
            }),
        ],
    };
};
//# sourceMappingURL=useCommandBarPosts.js.map